import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BreakPointService, Device, SvgIconComponent } from '@woolworthsnz/styleguide';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RecipeTimePipe } from '../../pipes';
import { formatServingsText } from '../helpers/servings-formatter';
import { RecipeTimePipe as RecipeTimePipe_1 } from '../../pipes/recipe-time.pipe';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';

export enum PrepSummaryMode {
	List = 'List',
	Summary = 'Summary',
}

@Component({
	selector: 'recipe-prep-summary',
	templateUrl: './prep-summary.component.html',
	styleUrls: ['./prep-summary.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, NgClass, SvgIconComponent, AsyncPipe, RecipeTimePipe_1],
})
export class PrepSummaryComponent {
	@Input() prepDuration?: number;
	@Input() cookDuration?: number;
	@Input() servings: string;
	@Input() mode: PrepSummaryMode = PrepSummaryMode.List;
	@Input() id: number;
	prepSummaryMode = PrepSummaryMode;

	isMobile$: Observable<boolean>;

	constructor(private breakPointService: BreakPointService, private recipeTimePipe: RecipeTimePipe) {
		this.isMobile$ = this.breakPointService.device$.pipe(map((device) => device === Device.MOBILE));
	}

	get serves(): string {
		return formatServingsText(this.servings);
	}

	get columnCountClass(): string {
		let columns = 0;
		if (this.prepDuration) {
			columns += 1;
		}
		if (this.cookDuration) {
			columns += 1;
		}
		if (this.serves) {
			columns += 1;
		}
		return `prepSummary-columns--${columns}`;
	}

	get prepAndCook(): string {
		if (!(this.prepDuration || this.cookDuration)) {
			return '';
		}

		let output = '';
		if (this.prepDuration) {
			output += 'Prep';
		}
		if (this.prepDuration && this.cookDuration) {
			output += ' & ';
		}
		if (this.cookDuration) {
			output += 'Cook';
		}
		output += ' Time';
		return output;
	}

	get label(): string {
		const labels: string[] = [];
		if (this.prepDuration) {
			labels.push(`Preparation time: ${this.recipeTimePipe.transform(this.prepDuration)}.`);
		}
		if (this.cookDuration) {
			labels.push(`Cook time: ${this.recipeTimePipe.transform(this.cookDuration)}.`);
		}
		if (this.serves) {
			labels.push(`Serves ${this.serves}.`);
		}
		return labels.join(' ');
	}
}
